import { Injectable } from '@angular/core';
import { HttpService } from '../providers/http.service';
import { AppConfig } from '../app/app.config';



@Injectable()
export class DailyWageReportService {
    constructor(
        private httpService: HttpService) { }


    //获取日工资报表信息
    //TQQ 2017-01-03
    getDailyWagesReports(startDate, endDate, pageIndex: number, pageSize: number) {
        let param = "start=" + startDate + "&end=" + endDate + "&pageSize=" + pageSize + "&pageIndex=" + pageIndex;
        let url = AppConfig.GetProdUrl() + "/User/GetDailyWagesReports?" + param;
        return this.httpService.get(url);
    }
    //获取下级用户的日工资报表
    getSubUserDailyWagesReports(subUserName,start, end, pageIndex: number, pageSize: number){
        let param = "subUserName=" +subUserName + "&start=" + start + "&end=" + end + "&pageIndex=" + pageIndex + "&pageSize=" + pageSize;
        let url = AppConfig.GetProdUrl() + "/Team/GetSubUserDailyWagesReports?" + param;
        return this.httpService.get(url);
    }

}





// WEBPACK FOOTER //
// ./src/services/dailywagesreport.service.ts